
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaTopCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Investment_Idea"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ideaType"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaTopCardHeaderFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaTopCardFooterFragment"},"directives":[]}]}}],"loc":{"start":0,"end":217}};
    doc.loc.source = {"body":"#import \"./components/Header/fragment.gql\"\n#import \"./components/Footer/fragment.gql\"\n\nfragment IdeaTopCardFragment on Investment_Idea {\n  id\n  ideaType\n  ...IdeaTopCardHeaderFragment\n  ...IdeaTopCardFooterFragment\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./components/Header/fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./components/Footer/fragment.gql").definitions));


      module.exports = doc;
    
